import {useEffect, useState} from "react";
import {theme} from "Theme";

import {useMapContext} from "base/map";
import {LocationRepository} from "poi/repository";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import PlaceIcon from "@mui/icons-material/Place";
import NotListedLocationOutlinedIcon from "@mui/icons-material/NotListedLocationOutlined";

const WAIT_INTERVAL = 500;

const IsocronasMapSelectPointAction = () => {
    const {selectedPoint, setSelectedPoint, setSearchedLocation} = useMapContext();

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [selectedValue, setSelectedValue] = useState(null);

    const search = value => {
        console.log("Search", {value});
        setLoading(true);
        LocationRepository.getList({search: value})
            .then(results => {
                setOptions(results);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const get = (id, type) => {
        LocationRepository.get(id, type).then(element => {
            console.log({element});
            setSearchedLocation({lat: element.lat, lng: element.lng});
            setSelectedPoint(`${element.lat},${element.lng}`);
        });
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (inputValue && inputValue.length > 2) {
                search(inputValue);
            }
        }, WAIT_INTERVAL);

        return () => clearTimeout(timeoutId);
    }, [inputValue]);

    useEffect(() => {
        if (selectedValue && selectedValue.id && selectedValue.type) {
            get(selectedValue.id, selectedValue.type);
            setInputValue(selectedValue.value);
        }
    }, [selectedValue]);

    return (
        <Stack
            justifyContent="flex-start"
            alignItems="center"
            direction="row"
            spacing={1}
            sx={{width: "100%"}}
        >
            <Typography
                variant="caption"
                sx={{fontSize: 10, whiteSpace: "wrap", width: 53}}
            >
                Origen
            </Typography>
            <Autocomplete
                freeSolo
                options={options}
                loading={loading}
                value={selectedValue}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                // onKeyDown={(event, value) => {
                //     if (event.key === "Enter") {
                //         // Prevent's default 'Enter' behavior.
                //         event.defaultMuiPrevented = true;
                //         // your handler code
                //     }
                // }}
                onChange={(event, newValue) => {
                    if (newValue && newValue?.id && newValue?.type) {
                        setSelectedValue(newValue);

                        console.log("Seleccionado:", newValue);
                        return;
                    }

                    setInputValue(newValue ? newValue : "");
                }}
                getOptionLabel={option => option.address || ""}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                filterOptions={x => x} // No filtrar, ya viene filtrado de la API
                sx={{
                    flex: 1,
                    borderColor: "red",
                    "& .MuiInputBase-root": {
                        height: "36px",
                    },
                    "& .MuiInputBase-input": {
                        padding: "10px 14px",
                        background: "transparent",
                    },
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: !selectedPoint
                                ? theme.palette.warning.light
                                : "#ccc",
                        },
                    },
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                        placeholder="Ej: Calle Fuentes, Alhama"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? (
                                        <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
                renderOption={(props, option) => (
                    <Box
                        component="li"
                        {...props}
                        key={option.id}
                        sx={{borderBottom: "1px solid #eee"}}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <Box sx={{flexGrow: 1, minWidth: 0}}>
                                <Typography variant="caption">
                                    {option.value}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                )}
                PaperComponent={props => (
                    <Paper {...props} sx={{mt: 0.5, boxShadow: 3}} />
                )}
                noOptionsText={
                    <Typography variant="caption" sx={{fontStyle: "italic"}}>
                        {inputValue.length < 3
                            ? "Escribe al menos 3 caracteres para buscar"
                            : "No se encontraron resultados"}
                    </Typography>
                }
                loadingText={
                    <Typography variant="caption" sx={{fontStyle: "italic"}}>
                        Buscando...
                    </Typography>
                }
            />
            {selectedPoint ? (
                <PlaceIcon
                    sx={{
                        color: "#2e85cb",
                    }}
                />
            ) : (
                <NotListedLocationOutlinedIcon
                    sx={{
                        color: theme.palette.warning.light,
                    }}
                />
            )}
        </Stack>
    );
};

export default IsocronasMapSelectPointAction;
